import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { EmailConfirmationLink } from '@/features/Profile/core/EmailConfirmationLink';

export const Card = styled.section<{ $hasBottomMargin: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;

  ${({ $hasBottomMargin }) =>
    $hasBottomMargin &&
    css`
      margin-bottom: 5px;
    `}
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 15px;
`;

export const Avatar = styled.div<{ $avatarUrl?: string }>`
  margin: 0 15px;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background-image: ${({ $avatarUrl }) =>
    $avatarUrl ? `url(${$avatarUrl})` : 'url(/images/profile-square.svg)'};
  background-size: cover;
  background-position: center;
`;

export const UserName = styled(Typography.Body).attrs({ $variant: '5' })`
  font-size: 18px;
  margin-bottom: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Meta = styled(Typography.Caption)`
  display: block;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const UserId = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const EmailConfirmationLinkBox = styled(EmailConfirmationLink)`
  min-height: 30px;
  padding: 8px 15px;
  border-radius: 12px;
`;

export const Balance = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 15px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const BalanceLabel = styled(Typography.Caption)`
  display: block;
  font-size: 14px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const BalanceValue = styled(Typography.Body).attrs({ $variant: '1' })`
  font-size: 18px;
  font-weight: 500;
`;

export const BalanceButton = styled(Button)`
  height: 35px;
`;
